import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Light client-side UI state. Persisted preferences (theme, sidebar collapse, page size) live
// in localStorage; the transient mobile-drawer flag does not persist.
export const useUiStore = create(
  persist(
    (set) => ({
      // 'light' | 'dark'
      colorMode: 'light',
      // desktop icon-rail collapse
      sidebarCollapsed: false,
      // mobile temporary drawer (transient — see partialize below)
      mobileNavOpen: false,
      // remembered default page size for paginated lists
      pageSize: 24,
      // preferred language for the topic reading view ('en' | 'hi' | 'hien')
      readerLang: 'en',

      toggleColorMode: () =>
        set((s) => ({ colorMode: s.colorMode === 'light' ? 'dark' : 'light' })),
      setColorMode: (mode) => set({ colorMode: mode }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setMobileNav: (open) => set({ mobileNavOpen: open }),
      setPageSize: (pageSize) => set({ pageSize }),
      setReaderLang: (readerLang) => set({ readerLang }),
    }),
    {
      name: 'cg.ui',
      partialize: (s) => ({
        colorMode: s.colorMode,
        sidebarCollapsed: s.sidebarCollapsed,
        pageSize: s.pageSize,
        readerLang: s.readerLang,
      }),
    },
  ),
);

export default useUiStore;
